export default __webpack_public_path__ + "static/media/Screenshot-3.e9f089a0.png";